import { useEffect, useState ,React} from 'react';
import axios from 'axios';


function ContactDetails() {
    const [isMobile, setIsMobile] = useState(window.innerWidth > 750);

    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth > 750);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);
    const handleSubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData.entries());
    
      try {
        const response = await axios.post('https://api.anab-co.com/send-email', data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        console.log('Response from server:', response);
        
        if (response.status === 200) {
          alert('Email sent successfully!');
        } else {
          alert('Failed to send email.');
        }
      } catch (error) {
        console.error('Error sending email:', error);
        alert('Failed to send email.');
      }
    };

  return (
    <div className="contact py-5">
      <div className="d-flex px-5 flex-row flex-wrap justify-content-center align-items-center py-5">
        <div className="col-md-6 col-12 d-flex flex-column justify-content-center my-3 align-items-start">
          <h1 style={{ fontSize:isMobile ? "60px" : "40px" }} className="sub-title py-3">Contact Us</h1>
          <div className='my-3 d-flex flex-column'>
            <div className=' d-flex flex-row align-items-center justify-content-between'>
            <i class="main-color fs-4 fa-solid fa-user px-2"></i>
            <div className='main-color'>
               <h4 className='my-0'> Managing Director</h4>
               <h6 className='my-0 second-color'>Mr.Ahmed Hadaeb </h6>
            </div>
            </div>
          </div>
          <div className='my-3 d-flex flex-column'>
            <div className=' d-flex flex-row align-items-center justify-content-between'>
            <i class="main-color fs-4 fa-solid fa-phone px-2"></i>
            <div className='main-color'>
               <h4 className='my-0'>Telephone</h4>
               <h6 className='my-0 second-color'>+20 106 7979630 || +20 120 0244130 </h6>
            </div>
            </div>
          </div>
          <div className='my-3 d-flex flex-column'>
            <div className=' d-flex flex-row align-items-center justify-content-between'>
            <i class="main-color fs-4 fa-solid fa-envelope px-2"></i>
            <div className='main-color'>
               <h4 className='my-0'> Emails</h4>
               <h6 className='my-0 second-color'>sales@anab-co.com || ahmed.hadaeb@anab-co.com </h6>
            </div>
            </div>
          </div>
          <div className='my-3 d-flex flex-column'>
            <div className=' d-flex flex-row align-items-center justify-content-between'>
            <i class="main-color fs-4 fa-solid fa-link px-2"></i>
            <div className='main-color'>
               <h4 className='my-0'> Social Media</h4>
               <h6 className='my-0 second-color'><a className='second-color text-decoration-none'  href="https://www.linkedin.com/in/anab-for-calcium-carbonate-8b7142335/" target="_blank" rel="noopener noreferrer">Linked<i class="fa-brands fa-linkedin-in"></i></a>
               </h6>
            </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-12 d-flex flex-column justify-content-center my-3 align-items-center">
          <form className="w-75 d-flex flex-column" onSubmit={handleSubmit}>
            <input className="contact-input mt-3 rounded-4 form-control" name="name" type="text" placeholder="Name" required />
            <input className="contact-input mt-3 rounded-4 form-control" name="email" type="email" placeholder="Email Address" required />
            <input className="contact-input mt-3 rounded-4 form-control" name="company" type="text" placeholder="Company" />
            <input className="contact-input mt-3 rounded-4 form-control" name="phone" type="text" placeholder="Phone" />
            <textarea className="contact-input mt-3 rounded-4 form-control" name="message" rows={5} placeholder="How can we help you?" required />
            <button className="dark-btn ms-auto rounded-5 my-4" type="submit">Send</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactDetails;
